import React from 'react';
import { RestaurantDetails_getRestaurantDetails } from '../../../../../types/graphql-types-generated.ts';
import { APIProvider, Map, Marker } from '@vis.gl/react-google-maps';
import { useIsSsr } from '../../../../../utils/hooks/use-is-ssr.tsx';
import { Button } from '../../../../../patterns/00-atoms/button/button.tsx';
import { UBTracking } from '../../../../../components/tracking/ubtracking.ts';

export type RestaurantInfoModalMapProps = {
  restaurantDetails: RestaurantDetails_getRestaurantDetails;
};

export const RestaurantInfoModalMap: React.FunctionComponent<
  RestaurantInfoModalMapProps
> = props => {
  const navigationLink = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(`${props.restaurantDetails.street} ${props.restaurantDetails.streetnumber}, ${props.restaurantDetails.linkedCity.name}`)}`;

  return (
    <div className="text-sm">
      <h3 className="mt-3 text-xl font-extrabold">Adresse</h3>
      <div className="mt-2 flex">
        <div className="flex-grow">
          <div className="font-bold">
            {props.restaurantDetails.street} {props.restaurantDetails.streetnumber}
          </div>
          <div className="font-medium">
            {props.restaurantDetails.zip} {props.restaurantDetails.linkedCity.name}
          </div>
        </div>
        <div>
          <Button
            href={navigationLink}
            target="_blank"
            onClick={() =>
              UBTracking.trackEvent.click(
                'restaurant_info_modal',
                'NAVIGATE_TO_RESTAURANT::GOOGLE_MAPS'
              )
            }
          >
            Navigieren
          </Button>
        </div>
      </div>
      {props.restaurantDetails.geoLat && props.restaurantDetails.geoLong && (
        <div className="mt-4 -mr-4 -mb-4 -ml-4 overflow-hidden rounded-b-3xl">
          <GoogleMap lat={props.restaurantDetails.geoLat} lng={props.restaurantDetails.geoLong} />
        </div>
      )}
    </div>
  );
};

type GoogleMapProps = {
  lat: number;
  lng: number;
};

const GoogleMap: React.FunctionComponent<GoogleMapProps> = props => {
  const { isSsr } = useIsSsr();

  if (isSsr) {
    return <></>;
  }

  return (
    <APIProvider apiKey="AIzaSyD_zSMQwQdos4t-pmFeCvMs-SENBZF6KqU">
      <Map
        style={{ width: '100%', height: '400px' }}
        defaultCenter={{ lat: props.lat, lng: props.lng }}
        defaultZoom={17}
        gestureHandling={'greedy'}
        disableDefaultUI={true}
        zoomControl={true}
        styles={[
          {
            stylers: [{ hue: '#d40f36' }]
          },
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }]
          }
        ]}
      >
        <Marker position={{ lat: props.lat, lng: props.lng }} />
      </Map>
    </APIProvider>
  );
};
